import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=ee6d8e9a&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports